// extracted by mini-css-extract-plugin
module.exports = {"root_div":"ViewRoles_root_div__kQKfk","tableContainer":"ViewRoles_tableContainer__1U-En","sectionTitle":"ViewRoles_sectionTitle__3X2bl"};